export default {
	Title: 'Brandis',
	Introduction: {
		Description: 'Расширение {title} — твой ключ\u00a0в\u00a0интерактивный\u00a0стриминг, где тебе\u00a0доступна\u00a0возможность запускать различные активности\u00a0для\u00a0зрителей прямо\u00a0во\u00a0время трансляции.',
		Notice: 'Не\u00a0забудь активировать расширение {title} на\u00a0канале перед\u00a0началом\u00a0трансляции.',
		Instructions: 'Всё что нужно\u00a0сделать для\u00a0начала, так это войти\u00a0в\u00a0твою личную\u00a0панель\u00a0управления\u00a0{title}, используя кнопку\u00a0на\u00a0экране. Там ты\u00a0создаешь или\u00a0выбираешь\u00a0уже\u00a0подготовленный интерактив, настраиваешь на\u00a0свой вкус и\u00a0запускаешь на\u00a0трансляции тогда, когда посчитаешь\u00a0нужным. Звучит\u00a0довольно просто, потому что это действительно просто! Начнём?'
	},
	Action: 'Панель Управления',
};
